export const openModel="Open_model"
export const closeModel="Close_model"